import { render, staticRenderFns } from "./TheRegisterImport.vue?vue&type=template&id=edb0c7c8&scoped=true&"
import script from "./TheRegisterImport.vue?vue&type=script&lang=js&"
export * from "./TheRegisterImport.vue?vue&type=script&lang=js&"
import style0 from "./TheRegisterImport.vue?vue&type=style&index=0&id=edb0c7c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb0c7c8",
  null
  
)

export default component.exports